import { User } from '@/types/User';

function isImaSanteAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'ima_sante';
}

function isImaMedicalAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'ima_medical';
}

function isImaAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'ima';
}

function isMatmutAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'matmut';
}

function isHesAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'hes';
}

function isAlmAccount(currentUser: User | null): boolean {
    return currentUser?.account_name === 'alm';
}

export {
    isImaAccount,
    isMatmutAccount,
    isImaSanteAccount,
    isImaMedicalAccount,
    isHesAccount,
    isAlmAccount,
};
